//Dependencies & helpers
import React, { useRef } from "react";
import { UserContext, translation } from "../../helpers";
//Components
import { Block } from "../../components";
//Styles
import "./Home.css";

const Home = () => {
  //Use translations
  const [state] = React.useContext(UserContext);
  const t = translation[state.lang].home;

  const compRef = useRef(null);

  //Render blocks
  const returnBlocks = () => {
    return t.blocks.map((block, index) => {
      return <Block key={index} props={block} />;
    });
  };

  return (
    <section id="home" ref={compRef}>
      {returnBlocks()}
    </section>
  );
};

export default Home;
